import React from 'react';
import { Row } from 'react-bootstrap';
import TickerNewsItem from './TickerNewsItem';

const TickerNews = ({ tickerNewsInfo }) => {
  if (!tickerNewsInfo.length) return null;

  return (
    <Row className="ticker-news-container">
      {tickerNewsInfo.map((item, index) => {
        return (
          <TickerNewsItem key={item.guid[0]._} newsItem={item} />
        );
      })}
    </Row>
  );
}

export default TickerNews;